// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"83ac220c","264":"bee5fefe","477":"bfe6b038","501":"af926228","991":"7e16f0ee","993":"ac6dd1bf"}[chunkId] + ".chunk.js";
};